import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { UpAndDown } from 'amira-intervention-library'; 
import useBlendingActivityWordMetadata from "../sharedHooks/useBlendingActivityWordMetadata";
import useFetchWordMetadata from "../../hooks/useFetchWordMetadata";
import get from 'lodash.get';

export default function UpAndDownTutor({ metadata, setDisableInterventionsForPhrase }) {

  const {
    speech,
    phrase,
    isFTUE,
    currentWordIndex,
    advanceOneWord,
    skipWord,
    isInstruction,
    hasInstructions,
    phraseMetadata,
    story,
    currentPageIndex,
    word,
    wordMetadata,
  } = metadata

  const { instructions } = phraseMetadata;

  useEffect(() => {
    setDisableInterventionsForPhrase(true);
  }, []);

  const { wordMetadata: exampleWordMetadata, loading: exampleLoading } = useFetchWordMetadata({ word: get(instructions, "text") })
  
  const example = instructions && instructions.text && exampleWordMetadata ? {
    word: instructions.text,
    GRAPHEMIC_BREAKDOWN: exampleWordMetadata.GRAPHEMIC_BREAKDOWN,
    PHON: exampleWordMetadata.PHON,
  }: null

  const onEnd = () => { 
    return;
  }

  if(exampleLoading) {
    return null;
  }
  
  return (
    <UpAndDown
      version={1}
      speech={speech}
      example={example}
      word={word}
      wordMetadata={wordMetadata}
      endOfPhrase={false}
      handleMessage={onEnd}
      ftue={isFTUE}
      tutorMode={true}
      currentWordIndex={currentWordIndex}
      phrase={phrase}
      phonemePlacementEnabled={true}
      advanceOneWord = {advanceOneWord}
      skipWord = {skipWord}
      isInstruction = {isInstruction}
      hasInstructions = {hasInstructions}
      story={story}
      currentPageIndex={currentPageIndex}
    />
  );
}

UpAndDownTutor.propTypes = {
  speech: PropTypes.object.isRequired,
  phrase: PropTypes.string.isRequired,
  isFTUE: PropTypes.bool.isRequired,
}